import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledExplanationListProps } from './ExplanationList.types';

export const StyledBody = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.cross.grayson};
`;

export const StyledTitle = styled.span`
  display: block;
  margin-bottom: ${rem('16px')};
  color: ${({ theme }) => theme.colors.cross.black};
`;

export const StyledIcon = styled.span`
  position: absolute;
  top: ${rem('-1px')};
  left: 0;
  width: ${rem('24px')};

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const StyledIntro = styled.div`
  font-size: ${rem('20px')};
  font-weight: 300;
  line-height: 1.4;
`;

export const StyledList = styled.ul<IStyledExplanationListProps>`
  margin: 0;
  padding: 0;
`;

export const StyledListItem = styled.li`
  position: relative;
  margin: ${rem('24px')} 0;
  padding-left: ${rem('32px')};
  list-style: none;
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
`;

export const StyledWrapper = styled.div`
  &:not(:first-child) {
    margin-top: ${rem('24px')};
  }
`;
